import { render, staticRenderFns } from "./achievement.vue?vue&type=template&id=ba4f9104&scoped=true"
import script from "./achievement.vue?vue&type=script&lang=js"
export * from "./achievement.vue?vue&type=script&lang=js"
import style0 from "./achievement.vue?vue&type=style&index=0&id=ba4f9104&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4f9104",
  null
  
)

export default component.exports